module.exports = __webpack_public_path__ + "static/media/nonstop.a8b2e228.png";